import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import ReactHlsPlayer from "react-hls-player";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Categories_list,
  GetChannelById,
  Languages_list,
  Partner_list,
  Theme_list,
  Timezone_list,
  epgHandlersList,
} from "../../api/api";
import "../../assets/css/style.scss";
import PlaceholderImage from "../../assets/svg/DetailsChannel/ImgBlank.svg";
import TvIcon from "../../assets/svg/DetailsChannel/TvIcon.svg";
import PlayIcon from "../../assets/svg/DetailsChannel/blackVideo.svg";
import MobileIcon from "../../assets/svg/DetailsChannel/mobileIcon.svg";
import TablateIcon from "../../assets/svg/DetailsChannel/tabletIcon.svg";
import WebIcon from "../../assets/svg/DetailsChannel/webIcon.svg";
import { image_url } from "../../service/Constant";
import "./channelDetails.scss";
import {
  defaultFileUploaded,
  defaultFormValue,
} from "../../dummyjson/channelDefaultValues";

function ChannelDetails() {
  const state = useSelector((state) => state);
  const Territorys = state?.CountryList?.data?.data || [];
  const Ratings = state?.MaturityList?.data || [];
  const locationState = useLocation();
  const navigate = useNavigate();

  const editChannel = (event) => {
    navigate("/channelCreation", {
      state: {
        id: event,
        permission: permission,
        currentPage: currentPage,
      },
    });
  };

  const [formData, setFormData] = useState({ ...defaultFormValue });
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [channelId, setChannelId] = useState("");
  const [playoutBaseUrl, setPlayoutBaseUrl] = useState("");
  const [apiUrl, setApiUrl] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [partnerOptions, setPartnerOptions] = useState([]);
  const [territoryOptions, setTerritoryOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [languageOptions, setLanguageOptions] = useState([]);
  const [themeOptions, setThemeOptions] = useState([]);
  const [epgHandlerData, setEpgHandlerData] = useState([]);
  const [ratingList, setRatingList] = useState([]);
  const [ratingsDescriptor, setRatingsDescriptor] = useState("");
  const [activeTab, setActiveTab] = useState("channelDetails");
  const [permission, setPermission] = useState(null);
  const [timezoneList, setTimezoneList] = useState([]);

  const backToChannel = () => navigate("/channel", { state: { currentPage } });
  useEffect(() => {
    fetchInitialData();
  }, []);
  const formatDate = (date) =>
    date ? moment(date).format("DD/MM/YYYY") : "dd/mm/yy";
  const formatBoolean = (value) => (value ? "Enabled" : "Disabled");
  const formatList = (list, key = "name") =>
    list?.length > 0 ? list.map((item) => item[key]).join(", ") : "-";
  const getRatingName = (id) => {
    if (!id) return "";
    if (!ratingList.length) return "-";
    const rating = ratingList.find((item) => item.id === Number(id));
    return rating ? rating.name : "Invalid Rating";
  };
  //get TimeZone List
  const getTimeZoneList = async () => {
    const Timezone = await Timezone_list();
    if (Timezone?.data) {
      setTimezoneList(Timezone?.data);
    }
  };
  function hoursToHHMM(value) {
    if (value == null || isNaN(value)) return "";

    const sign = value >= 0 ? "+" : "-";
    const totalMinutes = Math.round(Math.abs(value) * 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return `${sign}${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}`;
  }

  const getLanguageName = (languageId) => {
    if (!languageId) return "Hindi";
    const language = languageOptions.find((item) => item.id === languageId);
    return (
      <span className="label-bg-details">
        {language ? language.name : "Hindi"}
      </span>
    );
  };
  function formatCityName(name) {
    return name.replace(/^.*\//, "").replace(/_/g, " ");
  }
  const getTimeZone = (options) => {
    if (!options || options.length === 0)
      return <span className="label-bg-details">(GMT +05:30) Kolkata</span>;
    return options.map((option, index) => (
      <span className="label-bg-details" key={index}>
        {`(GMT ${hoursToHHMM(option.gmtOffset)}) ${formatCityName(
          option.timezone
        )}`}
      </span>
    ));
  };
const deepClone = (obj) => JSON.parse(JSON.stringify(obj));

  const parseChannelImages = (existingFiles) => {
    let channelImages = { ...deepClone(defaultFileUploaded)};
    existingFiles?.forEach((item) => {
      const device = item.size;
      if (channelImages[device]) {
        channelImages[device].poster.file = item.posterSourcePath
          ? `${image_url}${item.posterSourcePath}`
          : null;
        channelImages[device].thumbnail.file = item.thumbnailSourcePath
          ? `${image_url}${item.thumbnailSourcePath}`
          : null;
        channelImages[device].coverart.file = item.coverartSourcePath
          ? `${image_url}${item.coverartSourcePath}`
          : null;
      }
    });
    return channelImages;
  };

  const memoizedChannelImages = useMemo(
    () => deepClone(formData.channelImages),
    [formData.channelImages]
  );
  const fetchChannelData = async (id) => {
    const channelData = await GetChannelById(id);
    if (channelData) {
      const normalizedChannelTags = Array.isArray(channelData.channelTags)
        ? channelData.channelTags
        : channelData.channelTags?.split(",")?.filter(Boolean) || [];
      setFormData({
        ...channelData,
        channelTags: normalizedChannelTags,
        regionalLanguage: channelData.regionalLanguage?.id || "",
        channelImages: parseChannelImages(channelData.channelLogo),
        ratingId: channelData.rating?.id || "",
        timezones: channelData.timezones || null,
        fillerSourcePath: channelData.filler?.sourcePath
      });
      setName(channelData.name);
      setDescription(channelData.description);
      setChannelId(channelData.channelId);
      setPlayoutBaseUrl(channelData.playoutBaseUrl);
      setApiUrl(channelData.epgTypeApiUrl);
    }
  };

  const truncateDescription = (text, maxLength = 150) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength).trim() + "...";
  };

  const convertToHHMMSS = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${remainingSeconds.toString().padStart(2, "0")}`;
  };
  const fetchInitialData = async () => {
    const [partners, languages, categories, themes, epgHandlers] =
      await Promise.all([
        Partner_list(),
        Languages_list({ searchText: "", ignorePagination:true }),
        Categories_list({ searchText: "", sortBy: "name", sortOrder: "asc",ignorePagination:true }),
        Theme_list({ searchText: "", sortBy: "name", sortOrder: "asc", ignorePagination:true }),
        epgHandlersList(),
      ]);

    setPartnerOptions(partners?.data?.content || []);
    setLanguageOptions(languages?.content || []);
    setCategoryOptions(categories?.content || []);
    setThemeOptions(themes?.content || []);
    setEpgHandlerData(epgHandlers?.data || []);
    setRatingList(Ratings);
    getTimeZoneList();

    if (locationState?.state?.id) {
      setIsEdit(true);
      setCurrentPage(locationState.state.currentPage);
      fetchChannelData(locationState.state.id);
    }
  };

  useEffect(() => {
    if (Territorys.length > 0) {
      const countries = Territorys.map((item) => ({
        territoryId: item.iso,
        territoryName: item.niceName,
      })).sort((a, b) => a.territoryName.localeCompare(b.territoryName));
      setTerritoryOptions(countries);
    }
  }, [Territorys]);

  useEffect(() => {
    if (Ratings.length > 0 && formData.ratingId) {
      const selectedRating = Ratings.find(
        (item) => item.id === Number(formData.ratingId)
      );
      setRatingsDescriptor(selectedRating?.description || "");
    }
  }, [Ratings, formData.ratingId]);

  const renderOptions = (optionString, fallback) => {
    const options = optionString
      ? optionString.split(", ").map((opt) => opt.trim())
      : fallback.split(", ");
    return options.map((option, index) => (
      <span key={index} className="label-bg-details">
        {option}
      </span>
    ));
  };

  return (
    <div className="content-body channelDeatilsPage">
      <div className="dashboard-content">
        <div className="top-content">
          <div className="breadcrumbs">
            <ul>
              <li onClick={backToChannel}>Channel Management</li>
              <li className="active">{name}</li>
            </ul>
          </div>
        </div>

        <div className="channelDeatilsMainContent">
          {activeTab === "channelDetails" && (
            <div className="channel-container-Details">
              <div className="channel-details-left">
                {/* Channel Source */}
                <div className="channel-source channel-details-form">
                  <h2>Channel Source</h2>
                  <div className="form-row">
                    <div className="form-col">
                      <div className="form-field-details">
                        <label>Channel Name</label>
                        <span className="label-bg-details">{name || "-"}</span>
                      </div>
                    </div>
                    <div className="form-col">
                      <div className="form-field-details">
                        <label>Partner Name</label>
                        <div className="options-container">
                          {renderOptions(
                            formatList(formData.partners),
                            "Partner 1, Partner 2"
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Channel Details */}

                <div className="channel-details-form channel-detail">
                  <h2>Channel Details</h2>
                  <div className="form-row">
                    <div className="form-col">
                      <div className="form-field-details">
                        <label>Channel ID</label>
                        <span className="label-bg-details">
                          {channelId || "XXXXXX"}
                        </span>
                      </div>
                    </div>
                    <div className="form-col">
                      <div className="form-field-details">
                        <label>Channel Type</label>
                        <span className="label-bg-details">
                          {formData.type || "Linear"}
                        </span>
                      </div>
                    </div>
                    <div className="form-col">
                      <div className="form-field-details">
                        <label>Channel Assembly</label>
                        <span className="label-bg-details">
                          {formData.channelAssembly || "RUNN_MEDIA"}
                        </span>
                      </div>
                    </div>
                  </div>
                  {formData.channelAssembly === "EXTERNAL" && (
                    <>
                      <div className="form-row">
                        <div className="form-col">
                          <div className="form-field-details">
                            <label>EPG Handler</label>
                            <span className="label-bg-details">
                              {formData.epgHandler || "-"}
                            </span>
                          </div>
                        </div>
                        <div className="form-col">
                          <div className="form-field-details">
                            <label>EPG Type</label>
                            <span className="label-bg-details">
                              {formData.epgType || "API Driven"}
                            </span>
                          </div>
                        </div>
                      </div>
                      {formData.epgType === "APIDriven" && (
                        <div className="form-row">
                          <div className="form-col full-width">
                            <div className="form-field-details">
                              <label>API URL</label>
                              <span className="label-bg-details api-url">
                                {formData.epgTypeApiUrl || "-"}
                              </span>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                  <div className="form-row">
                    <div className="form-col">
                      <div className="form-field-details">
                        <label>Start Over</label>
                        <span
                          className={`label-bg-details ${
                            formData.isStartOverEnabled ? "enabled" : "disabled"
                          }`}
                        >
                          {formatBoolean(formData.isStartOverEnabled)}
                        </span>
                      </div>
                    </div>
                    <div className="form-col">
                      <div className="form-field-details">
                        <label>Watch Over</label>
                        <span
                          className={`label-bg-details ${
                            formData.isWatchListEnabled ? "enabled" : "disabled"
                          }`}
                        >
                          {formatBoolean(formData.isWatchListEnabled)}
                        </span>
                      </div>
                    </div>
                    <div className="form-col">
                      <div className="form-field-details">
                        <label>Force Login</label>
                        <span
                          className={`label-bg-details ${
                            formData.isForceLogin ? "enabled" : "disabled"
                          }`}
                        >
                          {formatBoolean(formData.isForceLogin)}
                        </span>
                      </div>
                    </div>
                    {formData.isForceLogin && (
                      <div className="form-col">
                        <div className="form-field-details">
                          <label>Duration <span className="format">(hh:mm:ss)</span></label>
                          <span className="label-bg-details">
                            {convertToHHMMSS(
                              formData.forceLoginWatchDuration || 300
                            )}
                          </span>
                        </div>
                      </div>
                    )}
                    <div className="form-col">
                      <div className="form-field-details">
                        <label>Kids Safe</label>
                        <span
                          className={`label-bg-details ${
                            formData.isKidsSafe ? "enabled" : "disabled"
                          }`}
                        >
                          {formatBoolean(formData.isKidsSafe)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-col">
                      <div className="form-field-details">
                        <label>Source Timezone</label>
                        <div className="options-container">
                          {getTimeZone(formData.timezones)}
                        </div>
                      </div>
                    </div>
                    {/* <div className="form-col">
                      <div className="form-field-details">
                        <label> Schedule Type </label>
                        <span className={`label-bg-details`}>
                          {formData.scheduleType}
                        </span>
                      </div>
                    </div> */}
                  </div>
                  <div className="form-row">
                    <div className="form-col">
                      <div className="form-field-details">
                        <label>Ratings</label>
                        <span className="label-bg-details">
                          {getRatingName(formData.ratingId) || "U-All Ages"}
                        </span>
                      </div>
                    </div>
                    <div className="form-col">
                      <div className="form-field-details">
                        <label>Enable Logo</label>
                        <span
                          className={`label-bg-details ${
                            formData.applyLogo ? "enabled" : "disabled"
                          }`}
                        >
                          {formatBoolean(formData.applyLogo)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-col">
                      <div className="form-field-details">
                        <label>Go-Live Date</label>
                        <span className="label-bg-details">
                          {formatDate(formData.goLiveDate)}
                        </span>
                      </div>
                    </div>
                    <div className="form-col">
                      <div className="form-field-details">
                        <label>Channel Setup Date</label>
                        <span className="label-bg-details">
                          {formatDate(formData.channelSetupDate)}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-col">
                      <div className="form-field-details">
                        <label>Territory</label>
                        <div className="options-container">
                          {renderOptions(
                            formatList(
                              formData.territoryDetails,
                              "territoryName"
                            ),
                            "Choice 1, Choice 2"
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="form-col">
                      <div className="form-field-details">
                        <label>Language</label>
                        {getLanguageName(formData.regionalLanguage)}
                      </div>
                    </div>
                  </div>
                  <div className="form-row"></div>
                  <div className="form-row">
                    <div className="form-col ">
                      <div className="form-field-details">
                        <label>Channel Category</label>
                        <div className="options-container">
                          {renderOptions(formatList(formData.categories), "-")}
                        </div>
                      </div>
                    </div>
                    <div className="form-col ">
                      <div className="form-field-details">
                        <label>Channel Theme</label>
                        <div className="options-container">
                          {renderOptions(formatList(formData.theme), "-")}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-row"></div>
                  <div className="form-row">
                    <div className="form-col full-width">
                      <div className="form-field-details">
                        <label>Channel Tags</label>
                        <div className="options-container">
                          {renderOptions(
                            Array.isArray(formData.channelTags) &&
                              formData.channelTags.length > 0
                              ? formData.channelTags.join(", ")
                              : "-",
                            "Tag 1, Tag 2"
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {formData?.channelAssembly !== "EXTERNAL" && (
                    <div className="form-row">
                      <div className="form-col full-width">
                        <div className="form-field-details">
                          <label>Default Filler</label>
                          <span className="label-bg-details">
                            {formData.fillerSourcePath || "-"}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="form-row">
                    <div className="form-col full-width">
                      <div className="form-field-details">
                        <label>Playout Base URL</label>
                        <span className="label-bg-details">
                          {playoutBaseUrl || "-"}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-col full-width">
                      <div className="form-field-details">
                        <label>Playback URL</label>
                        <span className="label-bg-details">
                          {formData.playbackUrl || "-"}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-col full-width">
                      <div className="form-field-details">
                        <label>Channel Description</label>
                        <span
                          className="label-bg-details description"
                          style={{ height: "auto" }}
                        >
                          {description || "-"}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-col full-width">
                      <div className="form-field-details">
                        <label>Custom Attributes</label>
                        <textarea
                          className="label-bg-details customAttributeBox"
                          style={{
                            width: "100%",
                            height: "200px",
                            fontFamily: "monospace",
                            whiteSpace: "pre-wrap", // wrap long lines
                            wordWrap: "break-word", // break long words
                            overflowX: "hidden", // no horizontal scrollbar
                            overflowY: "auto", // only vertical scroll
                            border: "none",
                            outline: "none",
                            scrollbarGutter: "stable",
                            boxSizing: "border-box",
                            resize: "none",
                          }}
                          wrap="soft" // allows word wrapping
                          value={JSON.stringify(
                            formData.customAttributes,
                            null,
                            2
                          )}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="channel-details-right">
                <div className="videoPlayerSection">
                  <h2>Channel Preview</h2>
                  <div className="demo-video-section">
                    {formData.playbackUrl ? (
                      formData.playbackUrl.endsWith(".m3u8") ? (
                        <ReactHlsPlayer
                          src={formData.playbackUrl}
                          autoPlay={false}
                          controls={true}
                          muted={true}
                          width="100%"
                          height="auto"
                          style={{ borderRadius: "4px" }}
                        />
                      ) : (
                        <video
                          src={formData.playbackUrl}
                          controls
                          style={{
                            width: "100%",
                            height: "auto",
                            borderRadius: "4px",
                          }}
                        />
                      )
                    ) : (
                      <div
                        style={{
                          height: "280px",
                          width: "503px",
                          backgroundColor: "#1e1e1e",
                          borderRadius: "14px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#ffffff",
                          fontSize: "18px",
                          fontWeight: "bold",
                          textAlign: "center",
                          boxShadow: "0 0 0 0.5px #D22B26",
                        }}
                      >
                        <img
                          src={PlayIcon}
                          alt="Play Icon"
                          style={{
                            marginBottom: "10px",
                            width: "40px",
                            height: "40px",
                          }}
                        />
                        Channel isn’t live
                      </div>
                    )}
                  </div>
                </div>

                <div className="logoSection">
                  <h2>Channel Images</h2>
                  <div className="media-section">
                    {["Mobile", "TV", "Web", "Tablet"].map((device) => (
                      <div key={device} className="device-section">
                        <div className="media-row-heading">
                          <img
                            src={
                              device === "TV"
                                ? TvIcon
                                : device === "Web"
                                ? WebIcon
                                : device === "Mobile"
                                ? MobileIcon
                                : TablateIcon
                            }
                            alt={device}
                          />
                          <span>{device}</span>
                        </div>

                        <div className="media-row">
                          {["thumbnail", "poster", "coverart"].map(
                            (imageType, index) => {
                              const label =
                                index === 0
                                  ? "Logo [1:1]"
                                  : index === 1
                                  ? "Hero Poster [2:3]"
                                  : "Cover Poster [16:9]";

                              const isLogo = imageType === "thumbnail";

                              return (
                                <div
                                  key={`${device}-${imageType}`}
                                  className="media-item"
                                >
                                  <div
                                    className="media-image-container"
                                    style={{
                                      width:
                                        imageType === "coverart" ? "171px" : "",
                                      maxWidth:
                                        imageType === "coverart" ? "171px" : "",
                                    }}
                                  >
                                    <img
                                      src={
                                        memoizedChannelImages?.[device]?.[
                                          imageType
                                        ]?.file || PlaceholderImage
                                      }
                                      alt={`${device} ${imageType}`}
                                      className="no-image-box"
                                      style={{
                                        width:
                                          imageType === "coverart"
                                            ? "171px"
                                            : "",
                                        maxWidth:
                                          imageType === "coverart"
                                            ? "171px"
                                            : "",
                                        aspectRatio: index === 1 ? "1/1" : "",

                                        ...(memoizedChannelImages?.[device]?.[
                                          imageType
                                        ]?.file
                                          ? {}
                                          : {
                                              width:
                                                imageType === "coverart"
                                                  ? "171px"
                                                  : "36px",
                                              height: isLogo ? "24px" : "60px",
                                              objectFit: "contain",
                                            }),
                                      }}
                                    />
                                  </div>
                                  <p>{label}</p>
                                </div>
                              );
                            }
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="action-buttons">
            <button onClick={backToChannel} className="backBtn">
              Back
            </button>
            <button
              className="editBtn"
              onClick={(e) => {
                e.stopPropagation();
                editChannel(locationState.state?.id || formData.channelId);
              }}
            >
              Edit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChannelDetails;
